export const rmaLRPage = {
  detail: 'detail',
  confirmation: 'confirmation',
}

export const LRReasonId = 'lifetimeReplacement'

export const LRMainReason = 'mainReason'
